// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `student-section-header .heading-section {
  border-bottom: 1px solid #000;
}

student-section-header .heading {
  font-weight: bold;
  font-family: Rockwell, Verdana, Arial, sans-serif;
  font-size: 20px;
}
`, "",{"version":3,"sources":["webpack://./apps/lms/src/css/studentui/studentSectionHeader.css"],"names":[],"mappings":"AAAA;EACE,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,iDAAiD;EACjD,eAAe;AACjB","sourcesContent":["student-section-header .heading-section {\n  border-bottom: 1px solid #000;\n}\n\nstudent-section-header .heading {\n  font-weight: bold;\n  font-family: Rockwell, Verdana, Arial, sans-serif;\n  font-size: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
